import NewChallengeButton, {EditChallengeButton, DeleteChallengeButton} from 'components/NewChallengeButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch, useLocation, useHistory } from "util/router.js";
import {loadOfferings} from 'store/actions/offeringsActions'
import {Helmet} from 'react-helmet'
import ShareButton from 'components/ShareButton'
import SingleChallengePage from 'components/SingleChallengePage';
// import OfferingSection from 'components/OfferingSection';

const BASE_URL = process.env.REACT_APP_BOOKING_SUCCESS_URL

function ChallengesTable(props) {

  const {selectedOffering} = props

  const offerings = useSelector(state => state.instructor.offerings.filter(val => val.type === "challenge"));
  const widgetName = useSelector(state => state.instructor.instructor.widgetName)

  const tableData = offerings.map(val => {

    const actions = (
      // we've added some custom button actions
      <div className="d-flex d-row justify-content-end">
          <EditChallengeButton 
          {...props}
          toEdit={val}
          />
          <DeleteChallengeButton 
          toDelete={val}
          />
      </div>
    )

    const link = BASE_URL + "/iframe/" + widgetName + "/series/" + val.id
    const buyLink = (
      <div className="d-flex d-row align-items-center">
          <input
          style={{paddingRight: "50px"}}
          type="text" value={link} readOnly={true} className={"form-control"}/>
          <ShareButton link={link} 
          style={{marginLeft: "-50px"}}
          />
          
      </div>
    )
    const clickableName = (
        <a href="#" onClick={(e) => {
          e.preventDefault()
          if (selectedOffering) {
            selectedOffering(val)
          }
          // history.push(`${baseUrl}/class/${key}`)
      }}>
          {val.name}
      </a>
    )
    

    return {
      ...val,
      price: val.frequency === "subscription" ? "Subscription Only" : (val.pricingOptions?.length > 0 ? "options" : val.promoCodePurchaseOnly ? "Promo code" : `$${val.price}`),
      // price: val.promoCodePurchaseOnly ? "Promo code" : `$${val.price}`,
      status: val.active ? "Active": "Private",
      sessions: val.type === "pack" ? (val.count ?? "0") : "Unlimited",
      actions: actions,
      buyLink: buyLink,
      clickableName: clickableName
    }
  })

  return (
  <div>
      {tableData.length > 0 ? (
        <ReactTable
        data={tableData}
        filterable={false}
        columns={[
            {
            Header: "Name",
            accessor: "clickableName",
            minWidth: 150
            },
            {
            Header: "Direct Purchase Link",
            accessor: "buyLink",
            minWidth: 150
            },
            // {
            // Header: "Sessions",
            // accessor: "sessions",
            // minWidth: 100
            // },
            {
            Header: "Price",
            accessor: "price",
            width: 150
            },
            {
            Header: "Status",
            accessor: "status",
            width: 100
            },
            {
            Header: "Actions",
            accessor: "actions",
            sortable: false,
            width: 100
            // filterable: false
            }
        ]}
        defaultPageSize={10}
        showPaginationTop={false}
        showPaginationBottom={true}
        className="-highlight"
        />
      ) : (
        <div className="h-100 text-center">
          {/* <h3 className="font-weight-bold">Create a new package / sub</h3>
          <p>Get started now</p>
          <NewOfferingButton {...props}/> */}

        </div>
      )}

  </div>
  )
}


function ChallengesPage(props) {

  const {match } = props;
  const history = useHistory()
  // const location = useLocation()
  const dispatch = useDispatch();
  const partnerId = useSelector(state => state.instructor.instructor.platformID);
  useEffect(() => {
    // dispatch
    if(partnerId) {
      dispatch(loadOfferings())
    }
    
  }, [partnerId]);

  // useEffect(() => {
  //   // dispatch
  //   console.log("new offerings")
  //   console.log(offerings)
    
  // }, [offerings]);

 

    function Challenges() {
        return (<>

        <Helmet>
          <title>Communites</title>
        </Helmet>
        <div className="container px-0">
        <section>
            <div className='d-flex d-row justify-content-between align-items-center mb-4'>
            <h2 className="font-weight-bold">Communities</h2>
            <NewChallengeButton className="float-right" {...props}/>
            </div>
            <p><big>Build community by creating exclusive access groups with live classes, on demand video, and other resources like PDFs and playlists</big></p>
            <ChallengesTable
            {...props}
            history={history}
            baseUrl={match.url}
            selectedOffering={offering => {
                history.push(`${props.match.url}/c/${offering.id}`)
            }}
            // data={offerings}
            />
        </section>
        </div>
        </>
        );
    }

    console.log("RE_RENDER")
  return (
    <Switch>
      <Route path={`${props.match.url}/c/:offeringId`} component={SingleChallengePage} />
      {/* render={props => {
        console.log("awesome props, ", props)
        return <OfferingSection offeringId={} {...props} />
        return <h1>{props.match.params.packageId}</h1>
      }}/> */}
      <Route path="/">
        <Challenges />
      </Route>
    </Switch>
  );
}

export default ChallengesPage;
